import type { FormValues } from '#src/app/pages/petitionDetails/shared/types';

type PublicInitialValues = Pick<FormValues, 'public' | 'notPublic'>;

const publicInitialValues = {
	public: true,
	notPublic: false,
};

export function usePublicInitialValues(): PublicInitialValues {
	return publicInitialValues;
}
